import { useState } from "react";
import SectionHeading from "@/pages/home/components/SectionHeading";
import { rankingTabs } from "@/mocks/home";

const rankTone = ["text-primary-700", "text-accent-700", "text-secondary-700"];

const trendIcon: Record<string, { icon: string; className: string }> = {
  up: { icon: "ri-arrow-up-line", className: "text-accent-600" },
  down: { icon: "ri-arrow-down-line", className: "text-secondary-600" },
  same: { icon: "ri-subtract-line", className: "text-foreground-400" },
};

export default function RankingSection() {
  const [activeKey, setActiveKey] = useState(rankingTabs[0].key);
  const active = rankingTabs.find((t) => t.key === activeKey) ?? rankingTabs[0];

  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-950">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-start">
          <div>
            <span className="inline-flex items-center gap-2 h-7 px-3 rounded-full bg-background-800 text-background-100 text-xs font-label font-medium">
              <i className="ri-trophy-line" />
              热门榜单
            </span>
            <h2 className="mt-4 font-heading text-2xl md:text-4xl font-bold text-background-50 leading-tight">
              热度、口碑、新剧，
              <br className="hidden md:block" />
              三张榜换着看
            </h2>
            <p className="mt-4 text-sm md:text-base text-background-300 leading-relaxed max-w-lg">
              热度榜看当下讨论度，口碑榜看长期评价，新剧榜则偏向近期更新。
              三张榜的侧重不同，配合上面的类型筛选，更容易找到合口味的片子。
            </p>

            <div className="mt-7 inline-flex items-center gap-1 p-1 rounded-full bg-background-900">
              {rankingTabs.map((tab) => {
                const isActive = tab.key === activeKey;
                return (
                  <button
                    key={tab.key}
                    type="button"
                    onClick={() => setActiveKey(tab.key)}
                    className={`h-9 px-4 rounded-full text-sm font-label font-medium transition-colors cursor-pointer whitespace-nowrap ${
                      isActive
                        ? "bg-primary-500 text-background-950"
                        : "text-background-300 hover:text-background-50"
                    }`}
                  >
                    {tab.label}
                  </button>
                );
              })}
            </div>

            <dl className="mt-8 grid grid-cols-3 gap-4 max-w-md">
              <div>
                <dt className="font-heading text-2xl font-bold text-primary-400">12,600+</dt>
                <dd className="mt-1 text-xs text-background-400 font-label">收录条目</dd>
              </div>
              <div>
                <dt className="font-heading text-2xl font-bold text-primary-400">8 类</dt>
                <dd className="mt-1 text-xs text-background-400 font-label">片单类型</dd>
              </div>
              <div>
                <dt className="font-heading text-2xl font-bold text-primary-400">每日</dt>
                <dd className="mt-1 text-xs text-background-400 font-label">榜单更新</dd>
              </div>
            </dl>
          </div>

          <div className="rounded-lg border border-background-800 bg-background-900 p-4 md:p-6">
            <div className="flex items-center justify-between">
              <h3 className="font-heading text-lg font-bold text-background-50">
                {active.label}
              </h3>
              <span className="text-xs text-background-400 font-label">
                更新于每日 08:00
              </span>
            </div>

            <ol className="mt-4 divide-y divide-background-800">
              {active.items.map((item, index) => {
                const trend = trendIcon[item.trend];
                return (
                  <li
                    key={`${active.key}-${item.rank}`}
                    className="flex items-center gap-4 py-3.5"
                  >
                    <span
                      className={`w-8 font-heading text-lg font-bold shrink-0 ${
                        index < 3 ? rankTone[index] : "text-background-500"
                      }`}
                    >
                      {String(item.rank).padStart(2, "0")}
                    </span>
                    <div className="min-w-0 flex-1">
                      <p className="text-sm font-label font-medium text-background-50 truncate">
                        {item.title}
                      </p>
                      <p className="text-xs text-background-400 font-label">
                        {item.type}
                      </p>
                    </div>
                    <span className={`shrink-0 ${trend.className}`}>
                      <i className={trend.icon} />
                    </span>
                    <span className="w-10 text-right text-sm font-label font-semibold text-background-100 shrink-0">
                      {item.score}
                    </span>
                  </li>
                );
              })}
            </ol>

            <a
              href="#featured"
              className="mt-4 inline-flex items-center gap-2 h-10 px-5 rounded-md bg-primary-500 text-background-950 text-sm font-label font-medium hover:bg-primary-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-arrow-right-line" />
              去完整片单里挑
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}